'use client';

import { useState, useEffect } from 'react';
import CustomTable from '../../components/CustomTable';
import { ModalAlert } from '@/components/ModalStyled/Modal';
import { Box, HStack, Button, Text, Input } from '@chakra-ui/react';
import { BoxTitle } from '@/components/BoxTitle';
import ModalRetorno from '../../components/ModalRetorno';

interface TableProps {
  headers: any;
  onDelete: (selectedData: any[]) => void;
  dados: any[];
  valoPesquisa: string;
}

export default function TabelaTipoCarga({ headers, onDelete, dados, valoPesquisa }: TableProps) {
  const [tableData, setTableData] = useState(dados);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newTipoCarga, setNewTipoCarga] = useState('');

  // Estados para o modal de retorno (feedback)
  const [modalRetornoOpen, setModalRetornoOpen] = useState(false);
  const [mensagemRetorno, setMensagemRetorno] = useState('');
  const [tipoRetorno, setTipoRetorno] = useState<'sucesso' | 'erro'>('sucesso');

  useEffect(() => {
    setTableData(dados);
  }, [dados]);

  const handleDeleteRecords = (selectedData: any[]) => {
    const selectedIds = selectedData.map(item => item.id);
    const newData = tableData.filter(item => !selectedIds.includes(item.id));
    setTableData(newData);
    onDelete(selectedData);
    setMensagemRetorno("Tipo de carga excluído com sucesso!");
    setTipoRetorno("sucesso");
    setModalRetornoOpen(true);
  };

  const handleAddTipoCarga = () => {
    if (newTipoCarga.trim() !== '') {
      setTableData(prevData => [
        ...prevData,
        { id: prevData.length + 1, rota: newTipoCarga, ativo: true },
      ]);
      setNewTipoCarga('');
      setIsModalOpen(false);
      setMensagemRetorno("Tipo de carga adicionado com sucesso!");
      setTipoRetorno("sucesso");
      setModalRetornoOpen(true);
    }
  };

  const handleDataChange = (newData: any[]) => {
    setTableData(newData);
  };

  return (
    <>
      <CustomTable
        headers={headers}
        data={tableData}
        searchValue={valoPesquisa}
        onDelete={handleDeleteRecords}
        onAdd={() => setIsModalOpen(true)}
        onDataChange={handleDataChange}
        addButtonLabel="Adicionar"
        deleteButtonLabel="Excluir"
        showActions={true}
      />

      <ModalAlert
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={<Text fontSize="lg" ml={2}>Adicionar Novo Tipo de Carga</Text>}
        body={
          <Box mt={3}>
            <BoxTitle title="Tipo de Carga">
              <Input
                placeholder="Adicione um tipo de carga"
                value={newTipoCarga}
                onChange={(e) => setNewTipoCarga(e.target.value)}
              />
            </BoxTitle>
          </Box>
        }
        footer={
          <Button colorScheme="blue" onClick={handleAddTipoCarga}>
            Confirmar
          </Button>
        }
      />

      <ModalRetorno
        isOpen={modalRetornoOpen}
        onClose={() => setModalRetornoOpen(false)}
        mensagem={mensagemRetorno}
        tipo={tipoRetorno}
      />
    </>
  );
}
